module.exports = __webpack_public_path__ + "static/media/KioskLandingScreen.f8004b7b.png";